import { ascending } from "d3-array";

function getAllItems(poems, type) {
  const wordSet = new Set();
  poems.forEach(poem => {
    poem[`${type}s`].forEach(word => {
      wordSet.add(word);
    });
  });
  let words = [...wordSet];
  words.sort(ascending);
  Object.freeze(words);
  return words;
}

function countItems(poems, type, matchWord, matchType) {
  const wordMap = new Map();
  poems.forEach(poem => {
    if (!matchWord || poem[`${matchType}s`].includes(matchWord)) {
      poem[`${type}s`].forEach(word => {
        if (!wordMap.has(word)) {
          wordMap.set(word, 0);
        }
        wordMap.set(word, wordMap.get(word) + 1);
      });
    }
  });
  Object.freeze(wordMap);
  return wordMap;
}

export { getAllItems, countItems };
